import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import cs from 'classnames';
import ImageDumbo from '../../../../DeviationViews/Dumbo/Image';
/**
 *
 * IMPORTANT!
 * Currently to support green/mobile we are using inline
 * styles to render editor related content. Do NOT add
 * classes to anything here for now.
 */ const ImageDumbView = (props)=>/*#__PURE__*/ React.createElement(ImageDumbo, _object_spread_props(_object_spread({}, props), {
        className: cs('daeditor-thumb-image', props.deviation.isMature && 'ismature'),
        extraWrapStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
        }
    }));
ImageDumbView.displayName = 'ImageDumbView';
export default ImageDumbView;
